import masks from "@/app/utils/masks";
import ButtonBack from "@/view/components/ButtonBack";
import { Button } from "@/view/components/ui/button";
import { Input } from "@/view/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/view/components/ui/select";
import { Spinner } from "@/view/components/ui/spinner";
import useC6BankSimulation from "./useC6BankSimulation";

export default function C6BankSimulation() {
  const {
    loading,
    error,
    installmentsList,
    selectedInstallment,
    installmentInput,
    setInstallmentInput,
    currentInstallmentRef,
    handleSelectInstallment,
    handleContinue,
  } = useC6BankSimulation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <ButtonBack label="Simulação" />

        <div className="flex h-[50vh] flex-col items-center justify-center gap-1">
          <span className="font-semibold text-black01">
            Ofertas indisponíveis
          </span>
          <span className="text-black03">{error}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      <ButtonBack label="Simulação" />

      <div className="flex w-[30%] flex-col gap-4 rounded-2xl border bg-white p-5">
        <div>
          <label className="mb-2 block text-sm font-medium">
            Valor da parcela
          </label>

          <Input
            value={installmentInput}
            maxLength={12}
            onChange={(e) => {
              const raw = masks.number(e.target.value);

              if (!raw) {
                setInstallmentInput("");
                currentInstallmentRef.current = 0;
                return;
              }

              setInstallmentInput(masks.currency(raw));
              currentInstallmentRef.current = Number(raw) / 100;
            }}
          />
        </div>

        <div>
          <label className="mb-2 block text-sm font-medium">
            Quantidade de parcelas
          </label>

          <Select
            value={selectedInstallment ? String(selectedInstallment) : ""}
            onValueChange={(value) => handleSelectInstallment(Number(value))}
            disabled={!installmentsList.length}
          >
            <SelectTrigger>
              <SelectValue placeholder="Selecione" />
            </SelectTrigger>

            <SelectContent>
              {installmentsList.map((installment) => (
                <SelectItem key={installment} value={installment.toString()}>
                  {installment}x
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <Button className="w-full text-white" onClick={handleContinue}>
          Continuar
        </Button>
      </div>
    </div>
  );
}
